var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { platform } from "../../appEnv";
import webCall from "./web";
import mpWebCall from "./mpWeb";
import mpCall from "./mp";
import { ApiCallStage, platformType } from "../constants";
import { logger } from "../logger";
function getOptions(name, options, config) {
  if (name === void 0) {
    name = '';
  }
  var originOptions = (config || {}).originOptions;
  if (originOptions) {
    logger({
      stage: ApiCallStage.REQUEST,
      type: 'log',
      name: name,
      request: originOptions
    });
    logger({
      stage: ApiCallStage.MODIFIED_REQUEST,
      type: 'log',
      name: name,
      request: options
    });
  } else {
    logger({
      stage: ApiCallStage.REQUEST,
      type: 'log',
      name: name,
      request: options
    });
  }
  function getRes(state) {
    return function (res) {
      var _a;
      var cb = options === null || options === void 0 ? void 0 : options[state];
      if (!cb) return;
      logger({
        stage: ApiCallStage.RESPONSE,
        type: 'log',
        state: state,
        name: name,
        response: res
      });
      var modifyCallback = (_a = config === null || config === void 0 ? void 0 : config.modify) === null || _a === void 0 ? void 0 : _a[state];
      if (!modifyCallback) return cb(res);
      var modifiedRes = modifyCallback(res);
      cb(modifiedRes);
      logger({
        stage: ApiCallStage.MODIFIED_RESPONSE,
        type: 'log',
        state: state,
        name: name,
        response: modifiedRes
      });
    };
  }
  return __assign(__assign({}, options), {
    success: getRes('success'),
    fail: getRes('fail'),
    complete: getRes('complete')
  });
}
export function call(name, options, config) {
  var opts = getOptions(name, options, config);
  switch (platform) {
    case platformType.mp:
      return mpCall(name, opts);
    case platformType.web:
      return webCall(name, opts);
    case platformType.mpWeb:
      return mpWebCall(name, opts, config === null || config === void 0 ? void 0 : config.isSync);
  }
}
export default call;